import React from 'react';

export const FeedsIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='48'
            height='48'
            viewBox='0 0 48 48'
            fill='none'
        >
            <rect width='48' height='48' rx='8' />
            <path
                d='M30.0281 20.1469H42.0797C42.45 20.1469 42.75 19.8469 42.75 19.4766V7.42031C42.75 7.05 42.45 6.75 42.0797 6.75H30.0281C29.6578 6.75 29.3578 7.05 29.3578 7.42031V11.775H22.9969C22.8141 11.775 22.6641 11.925 22.6641 12.1078V22.4906H18.6469V17.9672C18.6469 17.5969 18.3469 17.2969 17.9766 17.2969H5.92031C5.55 17.2969 5.25 17.5969 5.25 17.9672V30.0234C5.25 30.3937 5.55 30.6937 5.92031 30.6937H17.9719C18.3422 30.6937 18.6422 30.3937 18.6422 30.0234V25.5H22.6594V35.8828C22.6594 36.0656 22.8094 36.2156 22.9922 36.2156H29.3531V40.5703C29.3531 40.9406 29.6531 41.2406 30.0234 41.2406H42.075C42.4453 41.2406 42.7453 40.9406 42.7453 40.5703V28.5234C42.7453 28.1531 42.4453 27.8531 42.075 27.8531H30.0281C29.6578 27.8531 29.3578 28.1531 29.3578 28.5234V33.2109H25.6734V14.7891H29.3578V19.4766C29.3578 19.8469 29.6578 20.1469 30.0281 20.1469ZM32.5359 9.93281H39.5672V16.9688H32.5359V9.93281ZM15.4641 27.5156H8.43281V20.4844H15.4641V27.5156ZM32.5359 31.0359H39.5672V38.0719H32.5359V31.0359Z'
                fill='#6257D2'
            />
        </svg>
    );
};
